import { State, paymentsTableColumnAdapter, PaymentsTableColumnInstance } from
  '@feature/payments-to-you/reducers/payments-to-you-table-columns.reducers';
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const selectPaymentTableColumnState = createFeatureSelector<State>('paymentTableColumn');

export const {
  selectIds,
  selectEntities,
  selectTotal,
} = paymentsTableColumnAdapter.getSelectors(selectPaymentTableColumnState);


export const selectEntityByWidgetId = (widgetId: string) => createSelector(selectEntities, (entities) => entities[widgetId.toString()]);

export function getAvailableColumns(widgetId: string) {
  return createSelector(
    [selectEntityByWidgetId(widgetId)],
      (paymentsTableColumnInstance: PaymentsTableColumnInstance) => {
          return paymentsTableColumnInstance.availableColumns;
    }
    );
}

export function getAllColumns() {
  return createSelector(
      [selectPaymentTableColumnState],
    (paymentsTableColumnState: State) => {
      return paymentsTableColumnState.availableColumns;
    }
  );

}
